import { useRef, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import {
  AVAILABILITY_CALENDAR_ROUTE,
  AVAILABILITY_LABEL,
  AVAILABILITY_ROUTE,
  RESCHEDULE_VISIT_PAGE_PATH,
} from '../../../utils/constants'
import { text } from '../Constants'
import { cleanProviderName } from '../helper'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const useBreadcrumbs = (state, provider) => {
  const { pathname } = useLocation()
  const breadCrumbs = useRef([])

  const isReschedulePage = pathname === RESCHEDULE_VISIT_PAGE_PATH

  useEffect(() => {
    if (state?.isVisits) {
      // Fixed two-element breadcrumbs for Reschedule Visit page from Visits
      breadCrumbs.current = [
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        {
          site: 'Visits',
          location: '/visits', // "/visits"
        },
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        {
          site: isReschedulePage ? 'Reschedule Visit' : 'New Visit',
          location: '',
        },
      ]
    } else if (state?.previousState) {
      breadCrumbs.current = [
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        {
          site: state.previousState.label || AVAILABILITY_LABEL,
          location: `${state.previousState?.route || AVAILABILITY_ROUTE}${state.previousState?.search || ''}`,
        },
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        {
          site: cleanProviderName(provider?.providerName || state?.provider?.providerName || 'Provider'), // Cleaned provider name
          location: `${state.previousState.calendarRoute || AVAILABILITY_CALENDAR_ROUTE}/${
            state.queryId || ''
          }${state?.search || ''}`,
          state: { ...state.previousState },
        },
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        {
          site: isReschedulePage ? text.RESCHEDULE_VISIT : text.NEW_VISIT,
          location: '',
        },
      ]
    } else {
      breadCrumbs.current = [
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        {
          site: AVAILABILITY_LABEL,
          location: AVAILABILITY_ROUTE,
        },
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        {
          site: isReschedulePage ? text.RESCHEDULE_VISIT : text.NEW_VISIT,
          location: '',
        },
      ]
    }
  }, [state, provider])

  return breadCrumbs.current
}
